module.exports = __webpack_public_path__ + "img/pen.0ca064de.svg";